import React from 'react'

interface FooterProps {
  className?: string
}

export default function Footer({ className = '' }: FooterProps) {
  return (
    <footer className={`w-full py-4 ${className}`}>
      <div className="flex items-center justify-center gap-1.5 text-xs text-gray-400 dark:text-gray-500">
        <span>&copy; {new Date().getFullYear()} Insight Atlas</span>
        <span className="text-gray-300 dark:text-gray-600">&middot;</span>
        <a
          href="/terms.html"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
        >
          Terms
        </a>
        <span className="text-gray-300 dark:text-gray-600">&middot;</span>
        <a
          href="/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
        >
          Privacy
        </a>
      </div>
    </footer>
  )
}
